import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Megaphone, Users } from 'lucide-react';

export default function EventsTabs({ active }) {
  const { language } = useLanguage();
  const tr = (lv, en, ru) => (language === 'lv' ? lv : language === 'ru' ? ru : en);

  const base = 'inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all';
  const activeCls = 'bg-[#D97736] text-white shadow-sm';
  const idle = 'bg-white text-[#5C5C5C] border border-[#E5E4E0] hover:border-[#D97736] hover:text-[#D97736]';

  return (
    <div className="flex flex-wrap gap-2" data-testid="events-tabs">
      <Link to="/listings?category=event" className={`${base} ${active === 'listings' ? activeCls : idle}`} data-testid="events-tab-listings">
        <Megaphone className="w-4 h-4" /> {tr('Pasākumu sludinājumi', 'Event listings', 'Объявления событий')}
      </Link>
      <Link to="/events" className={`${base} ${active === 'roles' ? activeCls : idle}`} data-testid="events-tab-roles">
        <Users className="w-4 h-4" /> {tr('Lomas un pieteikumi', 'Roles & applications', 'Роли и заявки')}
      </Link>
    </div>
  );
}
